import { render, staticRenderFns } from "./PanelAdmin.vue?vue&type=template&id=07720fe5&scoped=true&"
import script from "./PanelAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PanelAdmin.vue?vue&type=style&index=0&id=07720fe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07720fe5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07720fe5')) {
      api.createRecord('07720fe5', component.options)
    } else {
      api.reload('07720fe5', component.options)
    }
    module.hot.accept("./PanelAdmin.vue?vue&type=template&id=07720fe5&scoped=true&", function () {
      api.rerender('07720fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelAdmin.vue"
export default component.exports